import request from "@/utils/request";

export function login(data) {
    return request({
        url: "/login",
        method: "post",
        data
    });
}

export function getInfo(token) {
    return request({
        url: "/common/userCenterInfoNew",
        method: "get",
        params: { token }
    });
}

export function logout() {
    return request({
        url: "/logout",
        method: "post",
        data: {}
    });
}

/**
 * 短信登录码
 */
export function sendSmsCode(data) {
    return request({
        url: "/smsCode",
        method: "post",
        data
    });
}
/**
 * 邮箱验证码
 */
export function sendVerifyCode(data) {
    return request({
        url: "/sendVerifyCode",
        method: "post",
        data
    });
}
/**
 * 手机号注册
 */
export function registUser(data) {
    return request({
        url: "/registUser",
        method: "post",
        data
    });
}
/**
 * 重置密码
 */
export function rePassword(data) {
    return request({
        url: "/rePassword",
        method: "post",
        data
    });
}

/**
 * 商家注册保存
 */
export function saveOrUpdate(data) {
    return request({
        url: "/wap/shop/saveOrUpdate",
        method: "post",
        data
    });
}
